import axios from "axios";

export default {
  getSimulation(simulationData) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${process.env.CHECK_SERVICE_PUBLIC_PATH}/price`,
        params: { fallback: 1 },
        data: simulationData
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },

  getComparison(comparisonData) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${process.env.CHECK_SERVICE_PUBLIC_PATH}/comparison`,
        data: comparisonData
      })
        .then(response => resolve(response.data))
        .catch(error => {
          reject(error.response);
        });
    });
  },

  getPartner(agent) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: `${process.env.CHECK_SERVICE_PUBLIC_PATH}/partner`,
        params: {agent: agent}
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  }
};



// WEBPACK FOOTER //
// ./src/services/checkService.js